import {
  BuyerOfferDisplayStatus,
  type OfferResponse,
} from '@/modules/offers/buyers/types';

const ACTIVE_OFFER_STATUSES: BuyerOfferDisplayStatus[] = [
  BuyerOfferDisplayStatus.ACCEPTED,
  BuyerOfferDisplayStatus.COUNTER_RECEIVED,
  BuyerOfferDisplayStatus.RECEIVED_PRIVATE_OFFER,
];

export function getActiveOffers(offers?: OfferResponse) {
  return (
    offers?.objects?.filter((offer) =>
      ACTIVE_OFFER_STATUSES.includes(offer.offer_display_status)
    ) || []
  );
}
